import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import { Paper } from '@material-ui/core';
import { instanceAxios } from '../../InstanceAxios';

function Acessos() {
  const [perfis, setPerfis] = useState([]);
  const [perfilSelecionado, setPerfilSelecionado] = useState(null);
  const [menus, setMenus] = useState([]);
  const [checked, setChecked] = useState([]);
  const [alert, setAlert] = useState(false);
  const [alertType, setAlertType] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchPerfis = async () => {
      await instanceAxios(localStorage.getItem('toobiauth'))
        .get(`/perfil`)
        .then((res) => {
          setPerfis(res.data);
        })
        .catch((err) => {
          console.log(err);
          setAlertType('error');
          setMessage('Erro ao carregar os perfis,tente novamente mais tarde!');
          setAlert(true);
        });
    };
    const fetchMenus = async () => {
      await instanceAxios(localStorage.getItem('toobiauth'))
        .get(`/menu`)
        .then((res) => {
          setMenus(res.data);
        })
        .catch((err) => {
          console.log(err);
          setAlertType('error');
          setMessage(
            'Erro ao carregar os Funcionalidades,tente novamente mais tarde!'
          );
          setAlert(true);
        });
    };

    fetchPerfis();
    fetchMenus();
  }, []);

  return (
    <div style={{ margin: 20 }}>
      <Collapse in={alert}>
        <Alert severity={alertType} onClick={() => setAlert(false)}>
          {message}
        </Alert>
      </Collapse>
      <h1 style={{ textAlign: 'center' }}>Acessos</h1>
      <Grid container spacing={3} style={{ paddingTop: '1%' }}>
        <Grid item xs={6}>
          <Paper elevation={5} style={{ padding: 5 }}>
            <h2 style={{ fontSize: '1.2em' }}>Perfis</h2>
            <List>
              {perfis.map((p) => (
                <ListItem
                  button
                  onClick={() => {
                    const checkedLocal = [];
                    p.Acessos.forEach((a) => checkedLocal.push(a.id_menu));
                    setChecked(checkedLocal);
                    setPerfilSelecionado(p);
                  }}
                >
                  <ListItemText primary={p.nome} />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
        <Grid item xs={6}>
          <Paper elevation={5} style={{ padding: 5 }}>
            <h2 style={{ fontSize: '1.2em' }}>Funcionalidades</h2>
            <FormControl component="fieldset">
              <FormGroup>
                {menus.map((m) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={checked.includes(m.id)}
                        onChange={async (event, value) => {
                          console.log(value);
                          if (value) {
                            await instanceAxios(
                              localStorage.getItem('toobiauth')
                            )
                              .post(`/acesso`, {
                                id_menu: m.id,
                                id_perfil: perfilSelecionado.id,
                              })
                              .then((res) => {
                                setAlertType('success');
                                setMessage(
                                  'Funcionalidade Vinculada com Sucesso!'
                                );
                                setAlert(true);
                                // Atualizando Perfil Selecionado
                                const ps = perfilSelecionado;
                                ps.Acessos.push(res.data);
                                setPerfilSelecionado(ps);
                                // Atualizando Checked
                                const checkedLocal = [];
                                ps.Acessos.forEach((a) =>
                                  checkedLocal.push(a.id_menu)
                                );
                                setChecked(checkedLocal);
                                // Atualizando Perfis
                                const pfs = perfis;
                                pfs.forEach((pf) => {
                                  if (pf.id === perfilSelecionado.id) {
                                    pf = perfilSelecionado;
                                  }
                                });
                                setPerfis(pfs);
                              })
                              .catch((err) => {
                                console.log(err);
                                setAlertType('error');
                                setMessage('Erro ao Vincular Funcionalidade!');
                                setAlert(true);
                              });
                          } else {
                            await instanceAxios(
                              localStorage.getItem('toobiauth')
                            )
                              .delete(`/acesso/${perfilSelecionado.id}/${m.id}`)
                              .then((res) => {
                                setAlertType('success');
                                setMessage(
                                  'Funcionalidade Desvinculada com Sucesso!'
                                );
                                setAlert(true);
                                // Atualizando Perfil Selecionado
                                const ps = perfilSelecionado;
                                const indexPs = ps.Acessos.map((e) => {
                                  return e.id_menu;
                                }).indexOf(m.id);
                                ps.Acessos.splice(indexPs, 1);
                                setPerfilSelecionado(ps);
                                // Atualizando Checked
                                const checkedLocal = [];
                                ps.Acessos.forEach((a) =>
                                  checkedLocal.push(a.id_menu)
                                );
                                setChecked(checkedLocal);
                                // Atualizando Perfis
                                const pfs = perfis;
                                pfs.forEach((pf) => {
                                  if (pf.id === perfilSelecionado.id) {
                                    pf = perfilSelecionado;
                                  }
                                });
                                setPerfis(pfs);
                              })
                              .catch((err) => {
                                console.log(err);
                                setAlertType('error');
                                setMessage('Erro ao Vincular Funcionalidade!');
                                setAlert(true);
                              });
                          }
                        }}
                      />
                    }
                    label={m.nome}
                  />
                ))}
              </FormGroup>
              <FormHelperText>Vincule o acesso com o Perfil</FormHelperText>
            </FormControl>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}

export default Acessos;
